import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {FormControl, FormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import {BsDatepickerConfig, BsDatepickerDirective, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {EnumService} from 'src/app/api/module/erp/services/area-logada/enum/enum.service';
import {PropostaCotacaoService} from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import {TipoPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {GeoLocalizacaoService} from 'src/app/api/module/erp/shared/geo-localizacao/geo-localizacao.service';
import {ListaAuxiliaresService} from 'src/app/api/module/erp/shared/lista-auxiliares/lista-auxiliares.service';
import {CampoDataService} from 'src/app/api/module/erp/shared/services/campoData/campo-data.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {GuideService} from 'src/app/components/helper/service/crypton-guide/guide.service';
import {CustomValidators} from 'src/app/pages/area-logada/shared/validators/custom-validators';

@Component({
  selector: 'app-proposta-entidade-dependente',
  templateUrl: './proposta-entidade-dependente.component.html',
  styleUrls: ['./proposta-entidade-dependente.component.scss'],
})
export class PropostaEntidadeDependenteComponent implements OnInit, OnChanges {
  @Input() ObrigatoriedadePropostaAssociadoEntidade: boolean = false;
  @Input() entidadeId: any;
  @Input() heOdonto: boolean = false;
  @Input() somenteLeitura: boolean = false;
  @Input() somenteLeituraColaboradorBeneficiario: boolean = false;
  @ViewChild('datepicker', {static: false}) datepicker?: BsDatepickerDirective;
  @ViewChildren(BsDatepickerDirective)
  inputDataSelecionado: boolean = false;
  bsConfig!: Partial<BsDatepickerConfig>;
  minDate!: Date;
  maxDate!: Date;
  erroMessageDependente: boolean = false;
  formularioDependente!: FormGroup;
  isFormSubmited: boolean = false;
  listaDependentes = new Array<any>();
  listarGrauParentesco: any = [];
  listarGrauParentescoEnum: any = [];
  formTouched: boolean = false;
  editingIndex: number = -1;
  listaEstatusCivil: any;
  showFormDependente: boolean = false;
  showBtnAdd: boolean = true;
  listaCidades = new Array<any>();
  listaEstados = new Array<any>();
  nomeDependente: any;
  idadeDependente: any;
  modalRef?: BsModalRef;
  message?: string;
  title?: string = '';
  listaEnumTipoCotacao: any;
  listaEnumTipoPropostaDependente: any;
  analiseOperadoraAnterior: boolean = false;
  parentesco: any;
  tipoProposta: any;
  sexo: any;
  analiseReducaoCarencia: any;

  // Propriedades para controlar exibição dos documentos existentes
  // documentoCTPExistente: string = '';
  // documentoDAPOExistente: string = '';

  // Propriedades para controlar exibição dos inputs de upload
  mostrarInputUploadCTP: boolean = false;
  mostrarInputUploadDAPO: boolean = false;
  isCamposOperadoraSubmetidos = false;

  // Propriedades para controlar se um novo arquivo foi selecionado
  novoArquivoCTPSelecionado: boolean = false;
  novoArquivoDAPOSelecionado: boolean = false;
  documentosDependentes: any[] = [];
  listaEnumTipoPropostaOriginal: any[] = [];
  recenNascidoInvalido: boolean = false;
  hePropostaRecemNascido: boolean = false;
  mostrarBannerUrgente: boolean = false;
  mensagemBannerUrgente: string =
    'Atenção: Recém-nascido deve ser incluído em até 30 dias do nascimento para garantir isenção de carências contratuais.';
  // Propriedades para controle de recém-casado (comentadas conforme solicitado)
  mostrarDataCasamento: boolean = false;
  dataCasamentoInvalida: boolean = false;
  minWeddingDate: Date = new Date(new Date().getFullYear() - 10, 0, 1);
  ehVisualizar: boolean = false;
  formCompletoSomenteLeitura: boolean = false;

  mostrarMensagemPortabilidadeSumula: boolean = false;
  mensagemAlertaSumulaPortabilidade = `Se houver campo preenchido da operadora anterior, selecione a opção: <b>Desejo submeter-me a Análise Técnica de Redução de Carências</b>,
  e o tipo de proposta deve ser diferente de: <br> <b>SUMULA 21 ou PORTABILIDADE.</b>`;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private bsLocaleService: BsLocaleService,
    private _listaAuxiliaresService: ListaAuxiliaresService,
    private _geo: GeoLocalizacaoService,
    private _enumService: EnumService,
    private modalService: BsModalService,
    private _campoDataService: CampoDataService,
    private _propostaCotacaoService: PropostaCotacaoService,
    private _spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private _guideService: GuideService,
  ) {
    this.bsLocaleService.use('pt-br');
    this.minDate = new Date(1900, 0, 1);
    this.maxDate = new Date();
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
      maxDate: new Date(),
    };
  }

  ngOnInit(): void {
    this.listaDependentes = [];
    this.createDependentFormGroup();
    this.getListaEstatusCivil();
    this.buscarListaEstados();
    this.getEnums();
    this.somenteLeituraDependente();
  }

  async listaGrauParentesco() {
    this._propostaCotacaoService
      .buscarGrauParentesco(this.entidadeId)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe(data => {
        this.listarGrauParentesco = data && data;
      });
  }

  somenteLeituraDependente() {
    if (this.somenteLeitura || this.somenteLeituraColaboradorBeneficiario) {
      this.formularioDependente.controls['birthDate'].disable();
      this.formularioDependente.controls['branchCompanyContractKinshipId'].disable();
      this.formularioDependente.controls['proposalType'].disable();
      this.formularioDependente.controls['sex'].disable();
      this.formularioDependente.controls['analysisPeriodReductionCheck'].disable();
    }
  }

  getListaEstatusCivil() {
    this._listaAuxiliaresService.LitaEstadosCivil().subscribe(data => {
      this.listaEstatusCivil = data && data;
    });
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formularioDependente.valid;
  }

  ngOnChanges() {
    if (this.listaEnumTipoPropostaDependente?.length) {
      this.aplicarFiltroOdonto();
    }
  }

  aplicarFiltroOdonto() {
    if (this.heOdonto) {
      this.listaEnumTipoPropostaDependente = this.listaEnumTipoPropostaDependente.filter((x: any) => x.value === 1);
    }
  }

  getEnums() {
    this._enumService.getEnumsElegibilidade().subscribe(data => {
      this.listarGrauParentescoEnum = data && data[3]?.values; //ContractKinshipEnum
    });
    this._enumService.getEnumsContract().subscribe(data => {
      const tipoContratacao = data.find(
        (enumObj: {enumType: string}) => enumObj.enumType === 'ContractModalityProductEnum',
      );
      const tipoProposta = data.find((enumObj: {enumType: string}) => enumObj.enumType === 'ProposalTypeEnum');
      let lista = tipoProposta?.values || [];
      if (this.heOdonto) {
        lista = lista.filter((x: any) => x.value === 1 || x.name === 'NewMembership'); //'NovaAdesao'
      }
      this.listaEnumTipoPropostaDependente = lista;
      this.listaEnumTipoCotacao = tipoContratacao?.values || [];
    });
  }

  createDependentFormGroup() {
    this.formularioDependente = this.formBuilder.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      birthDate: new FormControl(null),
      age: new FormControl(null),
      civilStatusId: new FormControl('', [Validators.required]),
      sex: new FormControl('', [Validators.required]),
      cpf: new FormControl('', [Validators.required, CustomValidators.validaCPF]),
      cns: new FormControl('', [Validators.required]),
      mothersName: new FormControl('', [Validators.required]),
      branchCompanyContractKinshipId: new FormControl('', [Validators.required]),
      previousOperator: new FormControl(''),
      stateId: new FormControl(''),
      cityId: new FormControl(''),
      dwellTime: new FormControl(''),
      proposalType: new FormControl(null),
      analysisPeriodReductionCheck: new FormControl(false),
      weddingDate: new FormControl(),
    });

    // this.checarTempoPermanencia();

    const birthDate = this.formularioDependente.get('birthDate');
    birthDate &&
      birthDate.valueChanges.subscribe(birthDate => {
        const hoje = new Date();
        const nascimento = new Date(birthDate);

        // Verifica se a data de nascimento é válida e não é no futuro
        if (nascimento > hoje) {
          this.toastr.warning('Não é permitido data maior do que hoje!');
          this.formularioDependente.get('birthDate')?.reset();
          this.formularioDependente.get('age')?.reset();
          return;
        }
        CustomValidators.rertornarIdadeForm(birthDate, this.formularioDependente);
        //  this.checarTempoPermanencia();
        this.atualizarValorPorIdadeDependente();
      });
  }

  private checarTempoPermanencia() {
    const analysisControl = this.formularioDependente.get('analysisPeriodReductionCheck');
    if (!this.heOdonto) {
      // Para NÃO odonto - obrigatório ter algum valor (true ou false)
      if (
        (analysisControl && !this.tipoProposta && this.tipoProposta != TipoPropostaEnum.SUMULA) ||
        this.tipoProposta != TipoPropostaEnum.PORTABILIDADE
      ) {
        analysisControl?.setValidators([Validators.required]);
      }
      //analysisControl?.setValue(false);
    } else {
      // Se for odonto → não é obrigatório, valor padrão false
      analysisControl?.clearValidators();
      analysisControl?.setValue(false);
    }

    analysisControl?.updateValueAndValidity();
  }

  atualizarValorPorIdadeDependente() {
    const idade = this.formularioDependente.get('age')?.value;
    this.emitirIdade(idade);
  }

  onFieldChange() {
    if (this.formTouched) {
      this.erroMessageDependente = !this.isFormValid();
    }
    this.atualizarValorPorIdadeDependente();
  }

  async onEdit(index: number) {
    await this.listaGrauParentesco();
    this.showFormDependente = true;
    this.showBtnAdd = false;
    this.editingIndex = index;

    const dependente = this.listaDependentes[index];
    let idade = this.calcularIdadePessoa(dependente.birthDate);
    const aniversario = new Date(dependente.birthDate);

    this.parentesco = dependente.branchCompanyContractKinshipId;
    this.tipoProposta = dependente.proposalType;
    this.sexo = String(dependente.sex);
    this.analiseReducaoCarencia = dependente.analysisPeriodReductionCheck;

    this.regraRecenCasado(dependente.proposalType);

    // Preencher dados básicos do dependente
    this.formularioDependente.patchValue({
      name: dependente.name,
      branchCompanyContractKinshipId: dependente.branchCompanyContractKinshipId,
      cpf: dependente.cpf,
      civilStatusId: dependente.civilStatusId,
      cns: dependente.cns,
      mothersName: dependente.mothersName,
      sex: String(dependente.sex),
      birthDate: aniversario,
      age: idade,
      id: dependente?.id,
      proposalType: this.tipoProposta || dependente.proposalType,
      weddingDate: new Date(dependente.weddingDate),
    });

    // Preencher dados de redução de carência se existirem
    if (dependente.analysisPeriodReductionCheck && dependente.analysisPeriodReduction) {
      const reducaoCarencia = dependente.analysisPeriodReduction;

      this.formularioDependente.patchValue({
        analysisPeriodReductionCheck: true,
        proposalType: reducaoCarencia.previustModalityProduct || dependente.proposalType,
        previousOperator: reducaoCarencia.previousOperator,
        stateId: reducaoCarencia.stateId,
        cityId: reducaoCarencia.cityId,
        dwellTime: reducaoCarencia.dwellTime,
      });

      this.analiseOperadoraAnterior = true;
      this.inserirDadosAntigaOperadora(true);
    } else {
      this.formularioDependente.patchValue({
        analysisPeriodReductionCheck: this.analiseReducaoCarencia,
        previousOperator: null,
        stateId: null,
        cityId: null,
        dwellTime: null,
        // fileCTP: null,
        // fileDAPO: null,
      });

      this.analiseOperadoraAnterior = this.analiseReducaoCarencia;
      this.inserirDadosAntigaOperadora(this.analiseReducaoCarencia);
    }

    if (dependente.analysisPeriodReduction?.stateId) {
      this.listarCidadesPorEstado(dependente.analysisPeriodReduction.stateId);
    }

    this.atualizarValorPorIdadeDependente();
  }

  limparFormulario() {
    this.formularioDependente.reset();
    this.formularioDependente.get('priceValue')?.setValue(0);

    this.erroMessageDependente = false;
    this.isFormSubmited = false;
    this.formTouched = false;
  }

  onShowformDependente() {
    if (this.listaDependentes.length >= 6) {
      this.toastr.warning('Você pode adicionar no máximo 6 dependentes.');
      return;
    }
    this.listaGrauParentesco();
    this.showFormDependente = true;
    this.showBtnAdd = false;
    // this.mostrarBtnSubstituirArquivoDAPO = false;
    // this.mostrarBtnSubstituirArquivoCPT = false;
    // this.existeDAPOParaSalvar = false;
    // this.existeCTPParaSalvar = false;
    this.analiseReducaoCarencia = false;
    this.limparFormulario();
  }

  onCancelar() {
    this.showFormDependente = false;
    this.showBtnAdd = true;
    this.limparFormulario();
  }

  buscarListaEstados() {
    this._geo.ListStates().subscribe((data: any) => {
      this.listaEstados = data && data;

      const indexOutro = this.listaEstados.findIndex((item: {name: string}) => item.name === 'Outro');

      if (indexOutro > -1) {
        const outro = this.listaEstados.splice(indexOutro, 1)[0];
        this.listaEstados.push(outro);
      }
    });
  }

  onChangeState($event: any) {
    if ($event) {
      this.listarCidadesPorEstado($event);
    } else {
      this.formularioDependente.patchValue({cityId: null});
      this.listaCidades = [];
    }
  }

  listarCidadesPorEstado(id: any[]) {
    if (id) {
      let estado = [];
      estado.push(id);
      this._geo.ListCitiesByStates(estado).subscribe((data: any) => {
        this.listaCidades = data && data;
      });
    }
  }

  calcularIdadePessoa(birthDate: any): number {
    const idade = CustomValidators.calcularIdadePessoa(birthDate);
    return idade;
  }

  validarValor(valor: any): any {
    if (isNaN(valor) || valor == '') return 0;
    else return valor;
  }

  decline(): void {
    this.modalRef?.hide();
  }

  emitirIdade(idade: number) {}

  abrirModalDependenteValor(template: TemplateRef<any>, _nomeDependente?: string, aniversario?: any) {
    let nascimento;
    if (aniversario && aniversario !== '') {
      nascimento = this.calcularIdadePessoa(aniversario);
    }
    // Verifica se a idade foi passada como parâmetro; se não, pega do formulário
    const idade = nascimento !== undefined ? nascimento : this.formularioDependente.get('age')?.value;
  }

  campoDataSelecionado(event: FocusEvent, index?: number) {
    this.inputDataSelecionado = true;

    if (index !== undefined && index !== null) {
      this._campoDataService.campoDataSelecionado(event, undefined, undefined, index);
    } else {
      this._campoDataService.campoDataSelecionado(event, undefined, index as any);
    }
  }

  esconderCalendario(index?: number) {
    if (index !== null && index !== undefined) {
      if (this.inputDataSelecionado === true) {
        this._campoDataService.esconderCalendario(undefined, undefined, index);
      }
      return;
    }
    if (this.inputDataSelecionado === true) {
      this._campoDataService.esconderCalendario(this.datepicker, undefined, index);
    }
  }

  mostrarCalendario(index?: number) {
    this._campoDataService.inputDataSelecionado = false;
    this.inputDataSelecionado = false;
    if (index !== null && index !== undefined) {
      this._campoDataService.mostrarCalendario(undefined, undefined, index);
      return;
    }
    if (this.datepicker) {
      this._campoDataService.mostrarCalendario(this.datepicker, undefined, index);
    }
  }

  formatarCampoData(valor: string, campoId: string | number) {
    this._campoDataService.formatarCampoData(valor, campoId);
  }

  inserirDadosAntigaOperadora(mostrarFormulario: boolean) {
    this.analiseOperadoraAnterior = mostrarFormulario;
    const camposParaValidar = ['previousOperator', 'dwellTime', 'stateId', 'cityId'];
    this.mostrarMensagemPortabilidadeSumula = false;
    camposParaValidar.forEach(campo => {
      const control = this.formularioDependente.get(campo);

      if (mostrarFormulario) {
        control?.setValidators([Validators.required]);

        control?.markAsTouched({onlySelf: true});
        control?.markAsDirty({onlySelf: true});
        control?.updateValueAndValidity({onlySelf: true, emitEvent: false});
        if (!control?.value) {
          control?.setErrors({required: true}, {emitEvent: false});
        }
      } else {
        control?.clearValidators();
        control?.setErrors(null, {emitEvent: false});
        control?.markAsUntouched({onlySelf: true});
        control?.markAsPristine({onlySelf: true});
        control?.reset('', {emitEvent: false});
      }

      control?.updateValueAndValidity({onlySelf: true});
    });

    this.cdr.detectChanges();
  }

  validarCamposReducaoCarenciaDependente(): boolean {
    const camposOperadoraAnterior = ['stateId', 'cityId', 'previousOperator', 'dwellTime'];
    const reducaoCarenciaAtiva = this.formularioDependente.get('analysisPeriodReductionCheck')?.value;

    // Verifica se algum campo da operadora anterior foi preenchido
    const algumCampoPreenchido = camposOperadoraAnterior.some(campo => {
      const valor = this.formularioDependente.get(campo)?.value;
      return valor !== null && valor !== undefined && valor !== '';
    });

    // Se não há campos preenchidos, a validação passa
    if (!algumCampoPreenchido) {
      return true;
    }

    // Se há campos preenchidos, verifica se a redução de carência está ativa
    if (!reducaoCarenciaAtiva) {
      return false;
    }

    // Se a redução de carência está ativa, verifica se todos os campos obrigatórios estão preenchidos
    const todosCamposPreenchidos = camposOperadoraAnterior.every(campo => {
      const valor = this.formularioDependente.get(campo)?.value;
      return valor !== null && valor !== undefined && valor !== '';
    });

    return todosCamposPreenchidos;
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  adicionarOuAtualizarDependente() {
    this.erroMessageDependente = false;
    this.formTouched = true;
    this.checarTempoPermanencia();

    if (!this.validarCamposReducaoCarenciaDependente()) {
      this.erroMessageDependente = true;
      this.mostrarMensagemPortabilidadeSumula = true;
      this.toastr.warning(this.mensagemAlertaSumulaPortabilidade, '', {
        enableHtml: true,

        timeOut: 5000,
        progressAnimation: 'decreasing',
        closeButton: true,
        progressBar: true,
      });
      return;
    }
    if (!this.isFormValid()) {
      this.erroMessageDependente = true;
      this.toastr.warning('Verifique os campos obrigatórios.');
      return;
    }

    this.analiseReducaoCarencia = this.formularioDependente.controls['analysisPeriodReductionCheck'].value;
    this.criarObjetoDependente();
  }

  private criarObjetoDependente() {
    const analysisPeriodReductionCheck =
      this.analiseReducaoCarencia || this.formularioDependente.controls['analysisPeriodReductionCheck'].value;

    if (this.formularioDependente.valid) {
      this.showFormDependente = false;
      this.showBtnAdd = true;
      this.tipoProposta = this.formularioDependente.controls['proposalType'].value;
      this.analiseReducaoCarencia = this.formularioDependente.controls['analysisPeriodReductionCheck'].value;

      const dependenteVM = {
        name: this.formularioDependente.controls['name'].value,
        branchCompanyContractKinshipId:
          this.parentesco || this.formularioDependente.controls['branchCompanyContractKinshipId'].value,
        cpf: this.formularioDependente.controls['cpf'].value,
        civilStatusId: this.formularioDependente.controls['civilStatusId'].value,
        cns: this.formularioDependente.controls['cns'].value,
        mothersName: this.formularioDependente.controls['mothersName'].value,
        sex: this.sexo || String(this.formularioDependente.controls['sex'].value),
        birthDate: this.formularioDependente.controls['birthDate'].value,
        age: this.formularioDependente.controls['age'].value,
        id: this.formularioDependente.controls['id'].value,
        proposalType: this.tipoProposta || this.formularioDependente.controls['proposalType'].value,
        cityId: this.formularioDependente.controls['cityId'].value,
        dwellTime: this.formularioDependente.controls['dwellTime'].value,
        previousOperator: this.formularioDependente.controls['previousOperator'].value,
        stateId: this.formularioDependente.controls['stateId'].value,
        weddingDate: this.formularioDependente.controls['weddingDate'].value,
      };

      // Estrutura o objeto dependente
      const dependente: any = {
        ...dependenteVM,
        analysisPeriodReductionCheck: analysisPeriodReductionCheck,
      };

      // Adiciona analysisPeriodReduction apenas se analysisPeriodReductionCheck for true
      if (analysisPeriodReductionCheck) {
        dependente.analysisPeriodReduction = {
          dependentProposalId: dependenteVM.id,
          previousOperator: dependenteVM.previousOperator,
          proposalType: dependenteVM.proposalType,
          dwellTime: dependenteVM.dwellTime,
          stateId: dependenteVM.stateId,
          cityId: dependenteVM.cityId,
        };
      }

      // Remove campos desnecessários do objeto principal do dependente
      delete dependente.stateId;
      delete dependente.cityId;
      delete dependente.previousOperator;
      delete dependente.dwellTime;
      // Adiciona à lista principal de dependentes
      if (this.editingIndex > -1) {
        this.listaDependentes[this.editingIndex] = dependente;
        this.editingIndex = -1;
      } else {
        // Gera ID temporário se for novo dependente
        if (!dependente.id) {
          dependente.id = ''; // this.generateTempId();
        }
        this.listaDependentes.push(dependente);
      }
      this.atualizarValorPorIdadeDependente();
      this.limparFormulario();
    }
  }

  // Limpar documentos quando remover dependente
  onRemove(index: number) {
    this.listaDependentes.splice(index, 1);

    this.atualizarValorPorIdadeDependente();
  }

  /*
     data nascimento do dependente ser superior a 30 dias da data atual e selecionado como tipo de Proposta
     "Inclusão de recém nascido" mostrar uma alerta que não se adequa para esse tipo de proposta
    */
  validarDataNascimentoRecenNascido(dataNascimento: any, mostrarToast: boolean = true): void {
    const control = this.formularioDependente.get('birthDate');

    // Se não for proposta de recém-nascido, limpa os erros e sai
    if (!this.hePropostaRecemNascido) {
      control?.setErrors(null);
      this.recenNascidoInvalido = false;
      return;
    }

    // Se não tem data, marca como inválido se for obrigatório
    if (!dataNascimento) {
      this.recenNascidoInvalido = true;
      control?.setErrors({required: true});
      return;
    }

    const dataNasc = new Date(dataNascimento);
    const hoje = new Date();
    const diffDias = Math.floor((hoje.getTime() - dataNasc.getTime()) / (1000 * 60 * 60 * 24));

    this.recenNascidoInvalido = diffDias > 30;
    if (this.recenNascidoInvalido) {
      // Adiciona o erro ao controle
      control?.setErrors({recenNascidoInvalido: true});
      this.toastr.toastrConfig.preventDuplicates = true;
      // Mostra o toast de alerta se solicitado
      if (mostrarToast) {
        this.toastr.warning(
          'Este dependente tem mais de 30 dias. O tipo "Inclusão de Recém-nascido" pode não se aplicar sem carências. Considere "Inclusão com carências".',
          'Atenção',
          {
            timeOut: 10000, // 10 segundos
            closeButton: true,
            enableHtml: true,
          },
        );
      }
    } else if (control?.hasError('recenNascidoInvalido')) {
      // Remove apenas o erro de recém-nascido inválido, mantendo outros erros
      const errors = {...control.errors};

      delete errors['recenNascidoInvalido'];
      control.setErrors(Object.keys(errors).length ? errors : null);
    }
  }

  regraRecenCasado(tipoProposta: number) {
    const ehRecemCasado = tipoProposta === TipoPropostaEnum.RECEM_CASADO;
    this.mostrarDataCasamento = ehRecemCasado;
    this.dataCasamentoInvalida = false;
    const weddingDateControl = this.formularioDependente.get('weddingDate');

    if (ehRecemCasado) {
      weddingDateControl?.setValidators([Validators.required]);

      if (weddingDateControl?.value) {
        this.validarDataCasamento(weddingDateControl.value, true);
      }
    } else {
      weddingDateControl?.clearValidators();
      this.dataCasamentoInvalida = false;
    }

    weddingDateControl?.updateValueAndValidity();
  }
  regraRecenNascido(tipoProposta: any) {
    const ehRecemNascido = tipoProposta === TipoPropostaEnum.RECEM_NASCIDO;
    this.hePropostaRecemNascido = ehRecemNascido;
    this.recenNascidoInvalido = false;
    this.mostrarBannerUrgente = ehRecemNascido;

    this.formularioDependente.get('urgente')?.setValue(ehRecemNascido);

    const birthDateControl = this.formularioDependente.get('birthDate');

    if (ehRecemNascido) {
      this.toastr.warning(this.mensagemBannerUrgente, '', {
        timeOut: 10000, //10segundos
      });
      birthDateControl?.setValidators([Validators.required]);
      // Força a validação se já houver valor
      if (birthDateControl?.value) {
        this.validarDataNascimentoRecenNascido(birthDateControl.value);
      }
    } else {
      birthDateControl?.clearValidators();
      this.recenNascidoInvalido = false;
      // Limpa apenas o erro específico se existir
      if (birthDateControl?.hasError('recenNascidoInvalido')) {
        const errors = {...birthDateControl.errors};
        delete errors['recenNascidoInvalido'];
        birthDateControl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    birthDateControl?.updateValueAndValidity();
  }

  onTipoPropostaChange(tipoProposta: any): void {
    this.tipoProposta = tipoProposta;
    this.regraRecenCasado(tipoProposta);
    this.regraRecenNascido(tipoProposta);

    if (this.tipoProposta === TipoPropostaEnum.SUMULA || this.tipoProposta === TipoPropostaEnum.PORTABILIDADE) {
      this.formularioDependente.patchValue({
        analysisPeriodReductionCheck: false,
      });
      this.inserirDadosAntigaOperadora(false);
      this.radioButtonReducaoCarenciaSomenteLeitura();
    }
  }

  validarAntesEnviar(): boolean {
    const ehRecemNascido = this.formularioDependente.get('proposalType')?.value === TipoPropostaEnum.RECEM_NASCIDO;

    if (ehRecemNascido) {
      this.validarDataNascimentoRecenNascido(this.formularioDependente.get('birthDate')?.value);

      if (this.recenNascidoInvalido) {
        this.toastr.warning(
          'Para inclusão de recém-nascido, a data de nascimento não pode ser superior a 30 dias.',
          'Atenção',
        );
        return false;
      }
    }
    return true;
  }

  // data Casamento
  //inclusao dependente
  //  RN -Ao Selecionar "inclusão de recém casado", ter o campo de data do casamento, terá uma validação se a data do casamento for superior a 30 dias mostrar uma alerta que não se adequa para esse tipo de proposta
  // Valida a data do casamento
  validarDataCasamento(dataCasamento: any, mostrarToast: boolean = true): void {
    const control = this.formularioDependente.get('weddingDate');

    if (!this.mostrarDataCasamento) {
      control?.setErrors(null);
      this.dataCasamentoInvalida = false;
      return;
    }

    if (!dataCasamento) {
      this.dataCasamentoInvalida = true;
      control?.setErrors({required: true});
      return;
    }

    const dataCasamentoObj = new Date(dataCasamento);
    const hoje = new Date();
    const diffDias = Math.floor((hoje.getTime() - dataCasamentoObj.getTime()) / (1000 * 60 * 60 * 24));

    this.dataCasamentoInvalida = diffDias > 30;

    if (this.dataCasamentoInvalida) {
      control?.setErrors({dataCasamentoInvalida: true});
      this.toastr.toastrConfig.preventDuplicates = true;
      if (mostrarToast) {
        this.toastr.warning(
          'Casamento acima de 30 dias. O tipo ‘Inclusão de Recém-casado’ pode não se aplicar sem carências. Considere ‘Inclusão com carências".',
          'Atenção',
          {
            timeOut: 10000, // 10 segundos
            closeButton: true,
          },
        );
      }
    } else if (control?.hasError('dataCasamentoInvalida')) {
      // Remove apenas o erro de data de casamento inválida, mantendo outros erros
      const errors = {...control.errors};
      delete errors['dataCasamentoInvalida'];
      control.setErrors(Object.keys(errors).length ? errors : null);
    }
  }

  get maxWeddingDate(): Date {
    return new Date();
  }

  get minDataNascimento(): Date {
    const date = new Date();
    date.setDate(date.getDate() - 30); // 30 dias atrás
    return date;
  }

  // Retorna a data máxima permitida (hoje)
  get maxDataNascimento(): Date {
    return new Date();
  }

  somenteLeituraFormularioCompleto() {
    this.somenteLeitura = true;
    this.formularioDependente.disable();
    this.cdr.detectChanges();
  }

  radioButtonReducaoCarenciaSomenteLeitura(): boolean {
    return this.tipoProposta === TipoPropostaEnum.SUMULA || this.tipoProposta === TipoPropostaEnum.PORTABILIDADE;
  }
}
